// 調整班表 公告班表 支援班表
import * as types from '../actionType';

let initState = {
  resources: [],
  events: []
};

function AdjustmentScheduleDetailState(state = initState, action) {
  switch (action.type) {
      case types.ADJUSTMENT_SCHEDULE_SHEET_DETAIL_SUCCESS:
      case types.SUPPORT_SCHEDULE_SHIFT_SUCCESS_BY_DATE: {
        return action.result;
      }
      case types.EDIT_STAFF_WORKTIME_IN_ADJUST_SUCCESS: {
        let newState = JSON.parse(JSON.stringify(state));
        newState.events = newState.events.map(event => {
          if (event.id === action.result.id) {
            event.start = action.result.start;
            event.end = action.result.end;
          }
          return event;
        })
        return newState;
      }
      default:
        return state;
  }
}


export default AdjustmentScheduleDetailState;